import React, { useMemo, useRef } from 'react';
import classNames from 'classnames';
import { useBoolean, useSize } from 'ahooks';
import Action from './Action';
import './index.less';
import { IMoreWrapProps } from './interface';

const Index = ({
  children,
  className = '',
  actionText = ['收起', '更多'],
  maxHeight = 32, // 默认最大高度，超过这个高度就会展示操作按钮
  actionPositon = 'right',
  style = {},
}: IMoreWrapProps) => {
  const [visible, { toggle }] = useBoolean();
  const ref = useRef(null);
  const size = useSize(ref);

  /** 是否展示操作按钮 */
  const showAction = useMemo(() => {
    return !!(size?.height && size?.height > maxHeight);
  }, [size?.height, maxHeight]);

  return (
    <div
      className={classNames('fs-more-wrap', className, {
        [`fs-more-wrap-${actionPositon}`]: actionPositon,
        'fs-more-wrap-hide': !showAction,
      })}
      style={style}
    >
      <div style={{ height: visible || !showAction ? 'auto' : maxHeight, overflow: 'hidden' }}>
        <div ref={ref} className="fs-more-content">
          {children}
        </div>

        {showAction && <Action positon={actionPositon} text={actionText} toggle={toggle} visible={visible} />}
      </div>
    </div>
  );
};

export default Index;
